/** Девять модулей продукта — блок «Что система делает за вас» (как на dev-front). */
export const LANDING_FEATURES = [
  {
    icon: '⬡',
    t: 'Поиск и агрегация закупок',
    d: 'Заменяет разрозненный «старый» поиск по отдельным площадкам: система собирает извещения с разных источников в РФ и Казахстане в одну ленту. Ключевые слова, фильтры и сохранённые запросы — без переключения между сайтами.',
  },
  {
    icon: '◇',
    t: 'Анализ рисков',
    d: 'Система прогоняет документацию через правила 44/223-ФЗ (РФ) и типовые риски закупок, дополняет выводы ИИ. Вы видите, что может дисквалифицировать заявку, какие условия жёсткие по срокам и обеспечению, и куда смотреть в ТЗ — без ночного чтения на 200 страниц.',
  },
  {
    icon: '◐',
    t: 'Вероятность победы',
    d: 'До вложения недель в подготовку получаете оценку шансов с учётом критериев конкурса и контекста вашей компании. Проще отказаться от слабого лота и сосредоточиться на закупках, где у вас реальные преимущества.',
  },
  {
    icon: '◉',
    t: 'Живой чат с документацией',
    d: 'Задаёте вопросы по ТЗ и приложениям на человеческом языке — «какой срок поставки», «нужна ли лицензия», «что с авансом». Ответы со ссылками на фрагменты PDF: не нужно вручную искать формулировку в десятке файлов.',
  },
  {
    icon: '◈',
    t: 'Маржинальность участия',
    d: 'На этапе решения оцениваете, есть ли экономический смысл в контракте: цена, объём, себестоимость, риски штрафов. Меньше ситуаций, когда команда готовит заявку неделю, а потом выясняется, что сделка «в ноль» или в минус.',
  },
  {
    icon: '◎',
    t: 'Анализ критериев конкурса',
    d: 'ИИ выстраивает дерево критериев и требований: что важно для оценки, где нужны подтверждающие документы, какие пункты дают максимум баллов. Удобно готовить содержательную часть заявки, а не гадать по оглавлению.',
  },
  {
    icon: '▣',
    t: 'Этапы согласования',
    d: 'Чеклист задач с дедлайнами: юристы, бухгалтерия, руководитель, технический блок. Видно, что уже согласовано и что тормозит подачу — меньше срывов «всё в последний день» из-за забытых подписей.',
  },
  {
    icon: '⎔',
    t: 'Интеграция с Tenderplan',
    d: 'Уже ведёте поиск в Tenderplan? Подключите API-ключ в личном кабинете — существующие поисковые ключи подтянутся в AI-Tenders. Без ключа доступен встроенный поиск по агрегированным площадкам РФ и Казахстана.',
  },
  {
    icon: '◫',
    t: 'Встроенная CRM по тендерам',
    d: 'Списки, канбан-этапы, избранное и история анализов — в одном кабинете: видно, на каком этапе каждая закупка, кто добавил в работу и что уже разобрано ИИ. Не нужно вести параллельные таблицы в Excel и терять контекст между сотрудниками.',
  },
]

export const LANDING_FEATURES_INTRO =
  'Единый поиск и агрегация закупок с площадок России и Казахстана — вместо разрозненных сервисов и вкладок. Дальше — анализ документов, риски, маржа и подготовка заявки в одном кабинете.'

export const LANDING_FEATURES_DISCLAIMER =
  'Подсказки ИИ по рискам и срокам не заменяют юридическую экспертизу и внутренние регламенты вашей организации'
